import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'identicon',
    standalone: true,
})
export class IdenticonPipe implements PipeTransform {
    async transform(value: string): Promise<string> {
        const encoder = new TextEncoder();
        const data = encoder.encode(value);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hash = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
        return `https://www.gravatar.com/avatar/${hash}?d=retro`;
    }
}
